import axios from "axios";
import { UpdateWatchAlertRequest, UpdateWatchAlertResponse } from "redmond";
import { airPriceWatchApi } from "@b2bportal/air-price-watch-api";

export const updateWatch = (
  request: UpdateWatchAlertRequest
): Promise<UpdateWatchAlertResponse> => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await airPriceWatchApi(
        axios as any
      ).apiV0AlertWatchUpdatePost(request);
      resolve(res.data as any);
    } catch (e) {
      reject(e);
    }
  });
};
